<template>
  <div>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt class="icon-home" />
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li>
                <router-link to="/index">Trang chủ</router-link>
              </li>
              <li class="is-active">
                <a>Admin</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="container">
          <admin-menu :activeLink="'/room-management'" />
          <h2 class="title is-4 has-text-centered">Danh sách phòng họp</h2>
          <div style="margin-bottom: 30px;">
            <download-excel :fetch="fetchDataToExport" :fields="json_fields" type="xls">
              <span style="text-decoration: underline; color: blue; cursor: pointer;">Export thông phòng họp</span>
            </download-excel>
          </div>
          <div class="mt-20 mb-20" v-if="arrIndex&&arrIndex.length">
            <div class="columns">
              <div class="column is-3">
                <autocomplete :items="userList" :label="'Lọc theo tài khoản'" @input="filterByKeywordAcc"/>
              </div>
              <div class="column">
                <autocomplete :items="roomList" :label="'Lọc theo phòng họp'" @input="filterByKeyword"/>
              </div>
            </div>
          </div>
          <div>
            <div
              :class="{ 'checked': list.key === computedSelectedAlphabet }"
              :key="list.key"
              @click="scrollElement({ key: list.key, id: list.id })"
              class="user-link"
              v-for="list in alphabetAccount">
              <div>{{list.key}}</div>
            </div>
          </div>
          <b-table
            :data="filteredRooms"
            :paginated="false"
            :sort-icon-size="'is-small'"
            :sticky-header="true"
            class="table is-fullwidth"
            default-sort="username"
            ref="multiSortTable"
            v-if="filteredRooms&&filteredRooms.length">
              <template slot-scope="props">
                <b-table-column label="STT">
                  {{props.index+1}}
                </b-table-column>
                <b-table-column
                  :ref="props.row.username"
                  field="username"
                  label="Tài khoản"
                  sortable>
                    {{props.row.username}}
                </b-table-column>
                <b-table-column
                  field="rooms"
                  label="Phòng họp ( Số lượt tham gia tối đa )"
                  sortable>
                    <span v-if="props.row.rooms&&props.row.rooms.length" v-html="showRooms(props.row.rooms)"/>
                </b-table-column>
                <b-table-column label="Tạo phòng họp">
                  <button
                    @click="isComponentModalActive = true; selectedUser = props.row.username"
                    class="button is-info">Tạo phòng họp</button>
                </b-table-column>
                <b-table-column label="Cập nhật phòng họp">
                  <button
                    @click="openUpdateRoom(props.row)"
                    class="button is-info">Cập nhật phòng họp</button>
                </b-table-column>
                <b-table-column label="Xoá">
                  <button
                    @click="openRemove(props.row)"
                    class="button is-danger">
                      Xoá phòng họp</button>
                </b-table-column>
              </template>
          </b-table>
          <b-modal :active.sync="isComponentModalActive" class="modal-create-room">
            <div class="form-user">
              <div class="content-layout">
                <header class="modal-card-head">
                  <p class="modal-card-title">Thêm phòng họp</p>
                  <button class="delete" aria-label="close" @click="isComponentModalActive=false" />
                </header>
                <form @submit.prevent="addRoom" data-vv-scope="CreateRoom">
                <div class="content-layout__inner">
                  <b-field
                    :message="errors.first('CreateRoom.roomNumber')&&errors.first('CreateRoom.roomNumber').includes('giữa')?'Phòng họp phải gồm 8 chữ số': errors.first('CreateRoom.roomNumber')"
                    :type="{'is-danger': errors.has('CreateRoom.roomNumber')}"
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Phòng họp <span class="has-text-danger">*</span>
                    </template>
                    <b-input
                      data-vv-as="phòng họp"
                      name="roomNumber"
                      type="number"
                      v-model="createRoomId"
                      v-validate="'required|min_value:10000000'"/>
                  </b-field>
                  <b-field
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Conference template
                    </template>
                    <v-select
                      :options="conferenceTemplate"
                      class="room-dropdown"
                      name="conference-tempalte"
                      v-model="selectedConferenceTemplate"/>
                  </b-field>
                  <b-field
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      MCU pool order
                    </template>
                    <v-select
                      :options="poolOrder"
                      class="room-dropdown"
                      name="pool-order"
                      v-model="selectedPoolOrder"/>
                  </b-field>
                  <b-field
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Max Participants
                    </template>
                    <v-select
                      class="room-dropdown"
                      name="max-party"
                      :options="Array.from({length: 100}, (_, i) => i)"
                      v-model="selectedMaxParty"
                    />
                  </b-field>
                </div>

                <div class="modal-bottom-group field is-grouped is-grouped-centered">
                  <div class="control">
                    <b-button @click="isComponentModalActive=false">Huỷ</b-button>
                  </div>
                  <div class="control">
                    <b-button type="is-info" native-type="submit">Xác Nhận</b-button>
                  </div>
                </div>
                </form>
              </div>
            </div>
          </b-modal>
          <b-modal :active.sync="isRemoveModalActive">
            <div class="content-layout content-layout--booked-room">
              <header class="modal-card-head">
                <p class="modal-card-title">Xoá phòng họp</p>
                <button class="delete" aria-label="close" @click="isRemoveModalActive=false" />
              </header>
              <div class="content-layout__inner">
                <b-checkbox
                  v-for="(room, key) in listRoomSelected"
                  v-model="roomChecked"
                  :native-value="room.roomIdentifier"
                  :key="key"
                >{{ room.roomIdentifier }}</b-checkbox>
              </div>
              <div class="modal-bottom-group field is-grouped is-grouped-centered">
                <div class="control">
                  <button class="button" @click="isRemoveModalActive=false">Huỷ</button>
                </div>
                <div class="control">
                  <button class="button is-info" @click="removeRoom">Xác Nhận</button>
                </div>
              </div>
            </div>
          </b-modal>
          <b-modal :active.sync="isUpdateRoomModalActive" class="modal-create-room">
            <div class="form-user">
              <div class="content-layout">
                <header class="modal-card-head">
                  <p class="modal-card-title">Cập nhật phòng họp</p>
                  <button class="delete" aria-label="close" @click="isUpdateRoomModalActive=false" />
                </header>
                <form @submit.prevent="updateRoomUI" data-vv-scope="UpdateRoom">
                <div class="content-layout__inner">
                  <b-field
                    :message="errors.first('UpdateRoom.updateRoomNumber')"
                    :type="{'is-danger': errors.has('UpdateRoom.updateRoomNumber')}"
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Phòng họp <span class="has-text-danger">*</span>
                    </template>
                    <v-select
                      :options="updateRoomList"
                      class="room-dropdown"
                      data-vv-as="Phòng họp"
                      label="roomIdentifier"
                      name="updateRoomNumber"
                      v-model="selectedUpdateRoom"
                      v-validate ="'required'"/>
                  </b-field>
                  <b-field
                    custom-class="has-text-weight-normal body-text">
                    <template slot="label">
                      Max Participants
                    </template>
                    <v-select
                      :options="Array.from({length: 100}, (_, i) => i)"
                      class="room-dropdown"
                      name="max-party"
                      v-model="updateMaxParty"/>
                  </b-field>
                </div>
                <div class="modal-bottom-group field is-grouped is-grouped-centered">
                  <div class="control">
                    <b-button @click="isUpdateRoomModalActive=false">Huỷ</b-button>
                  </div>
                  <div class="control">
                    <b-button type="is-info" native-type="submit">Xác Nhận</b-button>
                  </div>
                </div>
                </form>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import { mapActions, mapState } from 'vuex'

import AccountService from '@/services/AccountService'
import Utils from '@/components/shared/Utils'

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)

export default {
  components: {
    AdminMenu: () => import("./AdminMenu"),
    Autocomplete: () => import("../shared/Autocomplete")
  },
  computed: {
    ...mapState("hostRoom", ["rooms"]),
    arrIndex() {
      let result = [];

      Object.keys(this.rooms).forEach(key => {
        result.push(this.rooms[key]);
      });

      return result.sort(this.sortName);
    },
    alphabetAccount() {
      const list = this.filteredRooms.map(acc => {
        return {
          name: acc.username,
          id: acc.username,
        }
      })
      return Utils.createAlphabetList(list)
    },
    computedSelectedAlphabet() {
      if(this.selectedAlphabet) {
        return this.selectedAlphabet
      }
      return this.alphabetAccount[0].key
    },
    filteredRooms() {
      if (this.keyword === '' && this.keywordUsername === '') return this.arrIndex
      let result

      result = this.arrIndex&&this.keyword != ''
        ? this.arrIndex.filter(({ rooms }) => {
            return rooms.some(({ roomIdentifier }) => {
              return roomIdentifier.includes(this.keyword);
            });
          })
        : this.arrIndex;

      result = result&&this.keywordUsername != ''
        ? result.filter(({ username }) => {
          return username.includes(this.keywordUsername)
        })
        : result;
      return result;
    },
    roomList() {
      return this.arrIndex.reduce((acc, curr) => {
        const rooms = curr.rooms.map(({ roomIdentifier }) => roomIdentifier);
        return [...acc, ...rooms];
      }, []);
    },
    userList() {
      return this.arrIndex.reduce((acc, curr) => {
        const rooms = curr.username
        return [...acc, rooms];
      }, []);
    },
  },
  created() {
    this.fetchRoomList()
    AccountService.fetchTemplateAndPool(this.$store.state.auth.token).then(res => {
      if(res.data.status) {
        this.conferenceTemplate = res.data.templatePool[0]
        this.poolOrder = res.data.templatePool[1]
      }
    })
  },
  data() {
    return {
      conferenceTemplate: null,
      createRoomId: null,
      json_fields: {
        "STT.": "stt",
        "Người quản lý": "username",
        "Phòng họp": "rooms"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      keyword: '',
      keywordUsername: '',
      groups: null,
      isComponentModalActive: false,
      isRemoveModalActive: false,
      isUpdateRoomModalActive: false,
      listRoomSelected: [],
      poolOrder: null,
      roomChecked: [],
      selectedAlphabet: null,
      selectedConferenceTemplate: null,
      selectedMaxParty: null,
      selectedPoolOrder: null,
      selectedUser: null,
      selectedUpdateRoom: null,
      totalRoom: 0,
      updateMaxParty: -1,
      updateRoomList: null,
    }
  },
  methods: {
    ...mapActions('hostRoom', ['createRoom', 'deleteRoom', 'fetchRoomList', 'updateRoom']),
    addRoom() {
      const roomId = this.createRoomId
      const username = this.selectedUser
      this.$validator.validateAll('CreateRoom').then((result) => {
        if(result) {
          this.createRoom({
            maxParty: this.selectedMaxParty,
            pool: this.selectedPoolOrder,
            roomId,
            template: this.selectedConferenceTemplate,
            username,
          })
          .then(res => {
            if (res.data.status) {
              alert("created")
              this.isComponentModalActive = false
            } else {
              alert(res.data.message)
            }
          });
        }
      })
    },
    async fetchDataToExport() {
      return this.rooms.map((room, index) => {
        return {
          stt: index + 1,
          username: room.username,
          rooms: this.showRooms(room.rooms)
        };
      });
    },
    filterByKeyword(keyword) {
      this.keyword = keyword;
    },
    filterByKeywordAcc(keyword) {
      this.keywordUsername = keyword;
    },
    reducer(obj1, obj2) {
      if (
        obj1.ownerUsername &&
        obj2.ownerUsername &&
        obj1.ownerUsername[0] === obj2.ownerUsername[0]
      )
        return obj1;
      return obj1;
    },
    removeRoom() {
      if (this.roomChecked.length > 0) {
        this.deleteRoom({
          username: this.selectedUser,
          rooms: this.roomChecked
        }).then(() => {
          alert("Removed!");
          this.isRemoveModalActive = false
        });
      } else {
        alert("Vui lòng chọn phòng họp cần xoá.")
      }
    },
    scrollElement(evt) {
      this.$refs.multiSortTable.initSort()
      this.$nextTick(() => {
        if(this.alphabetAccount.length) {
          this.selectedAlphabet = evt.key
          this.$refs[evt.id].$el.scrollIntoView(true)
          window.scrollBy(0, - 66)
        }
      })
    },
    showRooms(rooms) {
      if (rooms.length < 1) return "";
      return rooms.map(item => `${item.roomIdentifier} ( ${item.maxParty==-1?'Không giới hạn':item.maxParty} )`).join('<br>');
    },
    sortName(a, b) {
      const bandA = a.username.toUpperCase();
      const bandB = b.username.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    openRemove(user) {
      this.roomChecked = [];
      this.isRemoveModalActive = true;
      this.selectedUser = user.username;

      this.listRoomSelected = user.rooms;
    },
    openUpdateRoom(user) {
      this.isUpdateRoomModalActive = true
      this.selectedUser = user.username
      this.updateRoomList = user.rooms
    },
    updateRoomUI() {
      this.$validator.validateAll('UpdateRoom').then((result) => {
        if(result) {
          this.updateRoom({
            entityTag: this.selectedUpdateRoom.roomEntityTag,
            maxParty: this.updateMaxParty || -1,
            roomId: this.selectedUpdateRoom.roomIdentifier,
            username: this.selectedUser,
          })
          .finally(() => {
            this.isUpdateRoomModalActive = false
          })
        }
      })
    }
  },
  watch: {
    selectedUpdateRoom(value) {
      this.updateMaxParty = value.maxParty
    }
  }
};
</script>

<style lang="scss">
.room-dropdown {
  .vs__dropdown-toggle {
    padding-top: 4px;
    padding-bottom: 6px;
    border: 1px solid #888888;
  }
}
.modal-create-room {
  .modal-content, .modal-card {
    overflow: visible;
  }
}
</style>